import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

import MainLayout from "../../Layouts/Main_Layout";
import Header from "../../Header/header";
import HeaderMenu from "../../Header/header-menu";
import Isi from "../../ISI/Isi";
import IsiFrame from '../../ISI/Isi-frame';
import Footer from "../../Footer/Footer";
import './Unsubscribe.css'

export default function UnSubscribePage() {
  const navigate = useNavigate();
  const myRef = useRef(null)
  const url = process.env.REACT_APP_API_URL;
  const [show, setShow] = useState(true)
  const [anonId, setAnonId] = useState("");

  const executeScroll = () => {
    myRef.current.scrollIntoView();
    setShow(true)
  }

  const validateForm = (e) => {
    var sendForm = 1;
    var emailRegex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;;

    var email = document.getElementById('email');
    var option1 = document.getElementById('option1');
    var option2 = document.getElementById('option2');

    if (!email.value.match(emailRegex)) {
      sendForm = 0;
      email.classList.add('error');
    }
    else {
      email.classList.remove('error');
    }

    if (!option1.checked && !option2.checked) {
      sendForm = 0;
      option1.classList.add('error');
      option2.classList.add('error');
    }
    else {
      option1.classList.remove('error');
      option2.classList.remove('error');
    }

    if (option2.checked) {
      option1.checked = true;
    }
    return sendForm;
  }

  useEffect(() => {
    const getCookieValue = (cookieName) => {
      const cookieValue = document.cookie
        .split('; ')
        .find(row => row.startsWith(cookieName + '='))
        ?.split('=')[1];

      return cookieValue;
    };

    const calculateOffset = () => {
      const componentElement = myRef.current;

      if (myRef) {
        const offsetTop = componentElement.offsetTop;
        function handleScroll() {
          if (window.innerHeight + window.scrollY > offsetTop) {
            setShow(false);
          }
          else (
            setShow(true)
          )
        }

        window.addEventListener("scroll", handleScroll);


        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
      }
    };
    calculateOffset();
    const anonID = getCookieValue('Anon_ID');
    setAnonId(anonID)
    window.addEventListener('resize', calculateOffset);
    return () => {
      window.removeEventListener('resize', calculateOffset);
    };
  }, []);

  const unsubscribeForm = (e) => {
    e.preventDefault();
    var status = validateForm();
    var email = document.getElementById('email');
    if (status == 1) {
      fetch(`${url}/signup`, {
        method: 'POST',
        body: {
          email: email,
          source_name: "inbrija_pwp_brand_unsub",
          unsub_code: "inbrija-pwp",
          visitor_id: "00000000-0000-0000-0000-000000000000",
        },
        headers: {
          'Content-Type': 'application/json'
        }
      }).then((data) => {
        navigate('/unsubscribe-confirmation')
      })

    }
  }
  return (
    <MainLayout>
      <div className="unsubscribe">
        <Helmet>
          <title>Unsubscribe | INBRIJA® (levodopa inhalation powder)</title>
        </Helmet>
        <Header />
        <HeaderMenu>
          <div className="hero-section">
            <div className="container">
              <h1>Unsubscribe</h1>
            </div>
          </div>
        </HeaderMenu>
        <div className="brush-style"></div>

        <form className="unsubscribe-container container" id="form-unsubscribe" onSubmit={unsubscribeForm}>
          <div className="form-group unsubscribe-email-field">
            <label>Enter your email address and select the information you no longer wish to receive.</label>
            <input id="email" name="email" type="email" className="form-control" placeholder="Email Address" onChange={() => validateForm()} />
          </div>
          <div className="form-group unsubscribe-options-field">
            <label>Select the type(s) of communications to unsubscribe from:</label>
            <div className="radio_boxes">
              <div className="radio_box">
                <input type="checkbox" id="option1" onChange={() => validateForm()} />
                <label htmlFor="option1">All INBRIJA-related emails from Merz</label>
              </div>
              <div className="radio_box">
                <input type="checkbox" id="option2" onChange={() => validateForm()} />
                <label htmlFor="option2">All Merz communications</label>
              </div>
            </div>
          </div>
          <div className="unsubscribeButton">
            <button type="submit">Unsubscribe</button>
          </div> 
        </form>
        <div ref={myRef}><Isi /></div>
        {show ? <IsiFrame onClick={executeScroll} /> : ''}

        <Footer
          partNum="01/25 US-INB-2400111"
          year="2025"
          twitterCode="https://twitter.com/intent/tweet?text=Learn%20more%20about%20INBRIJA.%20INBRIJA%20is%20inhaled%20levodopa.%20Ask%20your%20doctor%20to%20learn%20more.%20https://www.inbrija.com"
          facebookLink="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.inbrija.com%2F&title=Learn%20more%20about%20INBRIJA&description=INBRIJA%20is%20inhaled%20levodopa.%20Ask%20your%20doctor%20to%20learn%20more." />
      </div>
    </MainLayout>
  )
}